export const colors = {
  'aero-blue': '#40E0D0',
  'amaranth': '#E72D4B',
  'amber': '#FFC107',
  'black': '#000000',
  'blue-stone': '#00675b',
  'cod-gray': '#111111',
  'concrete': '#F2F2F2',
  'dark-blue': '#00004E',
  'dodger-blue': '#2196F3',
  'dove-gray': '#666666',
  'dove-grey-2': '#707070',
  'emperor': '#555555',
  'fruit-salad': '#4CAF50',
  'gallery': '#F0F0F0',
  'gray': '#858585',
  'green': '#52AC41',
  'guardsman-red': '#BC0202',
  'iron': '#CACCCE',
  'jacarta': '#3C3067',
  'light-green': '#81D742',
  'mantis': '#64C458',
  'monza': '#D1002C',
  'nude': '#E0C7BF',
  'orange': '#F49900',
  'pacific-blue': '#08B0BA',
  'parsley': '#196419',
  'persian-green': '#009688',
  'pink': '#E71F7E',
  'primary-turquoise': '#08C4CF',
  'primary-turquoise-dark': '#06B0BA',
  'puerto-rico': '#52c7b8',
  'red': '#FF0000',
  'sea-blue': '#3EBCD3',
  'secondary-petrol': '#032B30',
  'secondary-petrol-light': '#819597',
  'shakespeare': '#54BBCB',
  'silver': '#CCCCCC',
  'silver-chalice': '#B1B1B1',
  'tertiary-light-sand': '#FBF9F7',
  'tertiary-sand': '#F6F4EF',
  'teal': '#009688',
  'tundora': '#424242',
  'white': '#FFFFFF',
  'mercury': '#E9E9E9',
}
